// App.js
import React from 'react';
import API from './api';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './Login';
import DashboardAdmin from './DashboardAdmin';
import DashboardTeacher from './DashboardTeacher';
import DashboardSuperAdmin from './DashboardSuperAdmin';
import DashboardParent from './DashboardParent';
import ForceLogoutRedirect from './ForceLogoutRedirect';
import VisitQRConfirm from './VisitQRConfirm';
import VisitConfirmPage from './VisitConfirmPage';
import ReportPrint from './ReportPrint';
import useVersionRefresh from './useVersionRefresh';
import VersionBanner from './VersionBanner';
import MagicLogin from './MagicLogin';
import SessionExpired from './SessionExpired';
import ParentMagicRequest from './ParentMagicRequest';
import TeacherMagicRequest from './TeacherMagicRequest';
import SessionReauthModal from './SessionReauthModal';


// Ako poželiš ponovo global 401 interceptor, možeš ovaj deo da vratiš
// API.interceptors.response.use(...)

const ProtectedRoute = ({ children, role, roles }) => {
  const token = localStorage.getItem('token');
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const location = JSON.parse(localStorage.getItem('location') || 'null');

  if (!token) return <Navigate to="/login" replace />;

  const allowedRoles = roles || (role ? [role] : null);
  if (allowedRoles && !allowedRoles.includes(user.role)) {
    return <Navigate to="/login" replace />;
  }

  // ✅ Best practice: parent ne zahteva location (geolokacija)
  const isParent = user.role === 'parent';

  // Ako želiš da samo teacher/admin zahtevaju location:
  if (!isParent && !location) {
    return <Navigate to="/login" replace />;
  }

  return children;
};


const App = () => {
  const basePath =
    (import.meta && import.meta.env && import.meta.env.BASE_URL) || // Vite
    process.env.PUBLIC_URL || // CRA
    '/';

  const { outdated, reload } = useVersionRefresh({ intervalMs: 60000, basePath });

  return (
    <Router basename={basePath !== '/' ? basePath : undefined}>
      {outdated && <VersionBanner onReload={reload} />}
	  <SessionReauthModal />
	  
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/" element={<Navigate to="/login" replace />} />

        {/* Magic link login (bez zaštite) */}
        <Route path="/magic-login" element={<MagicLogin />} />

        <Route
          path="/admin/*"
          element={
            <ProtectedRoute role="admin">
              <DashboardAdmin />
            </ProtectedRoute>
          }
        />

        <Route
          path="/teacher/*"
          element={
            <ProtectedRoute role="teacher">
              <DashboardTeacher />
            </ProtectedRoute>
          }
        />

        <Route
          path="/super/*"
          element={
            <ProtectedRoute roles={['super_admin']}>
              <DashboardSuperAdmin />
            </ProtectedRoute>
          }
        />

        <Route
          path="/parent/*"
          element={
            <ProtectedRoute roles={['parent']}>
              <DashboardParent />
            </ProtectedRoute>
          }
        />

        {/* NEZAŠTIĆENE rute dostupne roditeljima (bez tokena) */}
        <Route path="/visit/:id/qr" element={<VisitQRConfirm />} />
        <Route path="/visit/:id/confirm" element={<VisitConfirmPage />} />
        <Route path="/report/:id" element={<ReportPrint />} />
		
		<Route path="/session-expired" element={<SessionExpired />} />
		<Route path="/parent-login" element={<ParentMagicRequest />} />
		<Route path="/teacher-login" element={<TeacherMagicRequest />} />

        {/* Fallback */}
        <Route path="*" element={<ForceLogoutRedirect />} />
      </Routes>
    </Router>
  );
};

export default App;


